import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function addSpaceStickyUnified() {
  const stickyElements = document.querySelectorAll(".sticky.tab-group");
  if (!stickyElements || !stickyElements.length) return;

  const header = document.querySelector("#masthead");
  const headerHeight = header ? header.offsetHeight : 0;
  const OFFSET = 200; // mismo -200

  stickyElements.forEach((stickyElement) => {
    // Ancla: dentro de #sc-products el padre, y para el resto el siguiente DIV
    const isInsideProducts = !!stickyElement.closest("#sc-products");
    let anchorEl;

    if (isInsideProducts) {
        
      anchorEl = stickyElement.parentElement;

    } else {

      let nextDiv = stickyElement.nextElementSibling;
      while (nextDiv && nextDiv.tagName !== "DIV") {
        nextDiv = nextDiv.nextElementSibling;
      }
      anchorEl = nextDiv;
    }

    if (!anchorEl) anchorEl = stickyElement; // fallback seguro

    let lastScroll = window.scrollY || 0;

    window.addEventListener("scroll", () => {
      const currentScroll = window.scrollY || 0;
      const anchorTop = anchorEl.getBoundingClientRect().top + window.scrollY ;

      if (currentScroll > lastScroll && currentScroll > anchorTop) {

        gsap.to(stickyElement, { 
            y: 0, duration: 0 
        });

      } else if (currentScroll < lastScroll && currentScroll > anchorTop) {

        gsap.to(stickyElement, {
          y: headerHeight,
          // delay: 0.2,
          duration: 0.25,
          ease: "power1.inOut",
        });

      } else if (currentScroll < anchorTop) {

        gsap.killTweensOf(stickyElement);
        stickyElement.setAttribute("style", "transform: translate(0px, 0px);");

      } else {
        gsap.to(stickyElement, { 
            y: 0,
            duration: 0 });
      }

      lastScroll = currentScroll;
    });
  });
}

addSpaceStickyUnified();
